export default function About() {
    return (
      <div>
        <h1>About</h1>
        <p>Welcome to the About page!</p>
      </div>
    );
  }